import React from "react";
import { colors } from "../../themes/Colors";

const InfoCard = ({ image, title, paragraph, no }) => {
  return (
    <div
      style={{
        minWidth: 280,
        maxWidth: 280,
        width: 280,
        borderRadius: 8,
        minHeight: 460,
        backgroundColor: colors.white,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        margin: 20,
      }}
    >
      <img
        alt={`${title}`}
        src={image}
        style={{
          width: "100%",
          borderTopRightRadius: 8,
          borderTopLeftRadius: 8,
        }}
      />

      <div
        style={{
          width: "90%",
          marginTop: 15,
          fontWeight: "bold",
          display: "flex",
          alignItems: "center",
        }}
      >
        <div
          style={{
            minHeight: 30,
            maxHeight: 30,
            minWidth: 30,
            borderRadius: 100,
            backgroundColor: colors.primary,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginRight: 10,
            color: colors.white,
            fontWeight: "bold",
          }}
        >
          {no}
        </div>
        <h4 style={{ fontSize: 16 }}>{title}</h4>
      </div>
      <p style={{ width: "90%", fontSize: 12, lineHeight: 1.5 }}>{paragraph}</p>
    </div>
  );
};

export default InfoCard;
